import { useEffect, useState } from "react";
import { ref, set, onValue } from "firebase/database";
import type { IMeal } from "../types/types";
import { realtimeDb } from "../utils/firebase";

export function useMenu() {
  const [menu, setMenu] = useState<IMeal[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const mealInstances: IMeal[] = menu.flatMap((meal) =>
      Array.from({ length: meal.quantity ?? 1 }, (_, index) => ({
        ...meal,
        id: `${meal.id}__${index}`,
        quantity: 1
      }))
    );

  const menuRef = ref(realtimeDb, "menu")

  const updateMenu = async (updater: ((prev: IMeal[]) => IMeal[]) | IMeal[]) => {
    let value = mealInstances
    if (typeof updater === "function") {
      value = updater(value);
    } else {
      value = updater;
    }
    try {
      setMenu(value)
      await set(menuRef, value);
    } catch (err) {
      console.error("Błąd aktualizacji menu:", err);
    }
  }


  useEffect(() => {
      const unsubscribe = onValue(
        menuRef,
        snapshot => {
          const data = snapshot.exists() ? snapshot.val() : {};
          setMenu(Object.values(data));
          setLoading(false);
        },
        err => {
          setError(err.message);
          setLoading(false);
        }
      );

      return () => unsubscribe();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return { menu: mealInstances, setMenu: updateMenu, loading, error };
}
